<mat-toolbar color="primary">
    <span>Protocoles</span>
    <button (click)="newProtocol()" mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>note_add</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <form class="panel-header-search">
        <mat-form-field class="panel-header-search" appearance="legacy">
            <input type="text" matInput #searchInput>
            <fa-icon matSuffix [icon]="['fas','search']"></fa-icon>
        </mat-form-field>
    </form>  
</mat-toolbar>
<app-protocol-table #protocolTable [location]="'panel'"></app-protocol-table>